import { client } from "../../../api/client";
import { createAudit } from "../../audit/data/auditService";

const auditCustomField = async (action, id, payload) => {
  await createAudit({
    action,
    result: "Successful",
    source: `exportCustomField.${id}`,
    payload: JSON.stringify(payload),
  });
};

// tolerate array/null/malformed JSON so one bad item doesn't fail the whole fetch
const parseOptions = (options) => {
  if (Array.isArray(options)) return options;
  if (!options) return [];
  try {
    const parsed = JSON.parse(options);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Error parsing exportCustomField options:", options, error);
    return [];
  }
};

export const fetchExportCustomFields = async () => {
  try {
    const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "iquoteapi/exportCustomField");

    if (!response.ok) {
      console.error("Error fetching exportCustomFields:", response);
      return [];
    }

    const result = Array.isArray(response.data) ? response.data : []

    return result.map(item => ({
      ...item,
      options: parseOptions(item?.options),
    }));
  } catch (error) {
    console.error("Error fetching exportCustomFields:", error);
    return [];
  }
};

export const updateExportCustomField = async (exportCustomField) => {
    try {

      const body = {
        ...exportCustomField,
        options: JSON.stringify(exportCustomField?.options ?? []),
      }

      const response = await client.put(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/exportCustomField/" + exportCustomField.id, body);
      const isSuccess = response.ok ?? (response.status >= 200 && response.status < 300);

      if (isSuccess) {
          await auditCustomField("Export custom field updated", exportCustomField.id, exportCustomField);
          const savedField = response.data?.exportCustomField ?? exportCustomField;
          return {
            success: true,
            message: "Export Custom Field updated successfully",
            exportCustomField: {
              ...savedField,
              options: parseOptions(savedField.options),
            }
          };
      }

      if (response.status === 403) {
          return {
            success: false,
            message: "You do not have permission to update Export Custom Fields",
            exportCustomField: null
          };
      }

      return {
        success: false,
        message: "Error updating Export Custom Field: " + (response.statusText || response.status),
        exportCustomField: null
      };
    } catch (error) {
        console.error("Error updating exportCustomField:", error);
        return { success: false, message: "error:" + error, exportCustomField: null }
    }
}

export const deleteExportCustomField = async (target) => {
  try {
    const response = await client.delete(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/exportCustomField/" + target.id);
        if (response.status === 204) {
            await auditCustomField("Export custom field deleted", target.id, { name: target.name ?? "" });
            return { success: true, message: "Export Custom Field deleted successfully" };
        } if (response.status === 403) {
          return { success: false, message: "You do not have permission to delete Export Custom Fields." };
        }  else {
          return { success: false, message: "Error deleting Export Custom Field. Code: " + response.status };
        }
      } catch (error) {
          console.error("Error deleting exportCustomField:", error);
          return { success: false, message: "Error deleting Export Custom Field: " + error, exportCustomField: null }
      }
}

export const createExportCustomField = async (exportCustomField) => {
  try {
    const body = {
      ...exportCustomField,
      options: JSON.stringify(exportCustomField?.options ?? []),
    }

    const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/exportCustomField", body);

    if (response.status === 201) {
      await auditCustomField("Export custom field created", response.data?.exportCustomField?.id ?? exportCustomField.field, exportCustomField);
      const savedField = response.data?.exportCustomField;
      return {
        success: true,
        message: "Export Custom Field created successfully",
        exportCustomField: savedField ? {
          ...savedField,
          options: parseOptions(savedField.options),
        } : savedField,
      };
    } else if (response.status === 403) {
        return { success: false, message: "You do not have permission to create Export Custom Fields.", exportCustomField: null };
    } else {
        return { success: false, message: "Error creating Export Custom Field: Status=" + response.status, exportCustomField: null };
    }
  } catch (error) {
      console.error("Error creating exportCustomField:", error);
      return { success: false, message: "error:" + error, exportCustomField: null }
  }
}